import { Dayjs } from 'dayjs'

import FormDatePicker from 'components/forms/elements/FormDatePicker'
import FormSelectInput from 'components/forms/elements/FormSelectInput'
import FormTextInput from 'components/forms/elements/FormTextInput'
import { TSHIRT_SIZES } from 'constants/models'

const tandem = ({ formDisabled, updateField }) => ({
  id: 'tandem-form-details',
  name: 'Tandem Participant Information',
  inputs: [
    {
      id: 'tandemName',
      size: { sm: 12, md: 6 },
      field: (
        <FormTextInput
          name="tandemName"
          label="Name"
          required
          autoComplete="new-tandemName"
          disabled={formDisabled}
        />
      ),
    },
    {
      id: 'tandemBirthdate',
      size: { sm: 12, md: 6 },
      field: (
        <FormDatePicker
          name="tandemBirthdate"
          label="Birthdate"
          required
          autoComplete="new-tandemBirthdate"
          placeholder="YYYY-MM-DD"
          disabled={formDisabled}
          onModified={(value: Dayjs) =>
            updateField('tandemBirthdate', value, true)
          }
        />
      ),
    },
    {
      id: 'tandemShirtSize',
      size: { sm: 12, md: 6 },
      field: (
        <FormSelectInput
          name="tandemShirtSize"
          label="Shirt size"
          autoComplete="new-tandemShirtSize"
          placeholder="Select Shirt Size"
          disabled={formDisabled}
          options={Object.entries(TSHIRT_SIZES).map(([key, value]) => ({
            value: key,
            text: value,
          }))}
          required
        />
      ),
    },
  ],
})

export default tandem
